import React, { FunctionComponent, useState } from 'react';

import { RESOURCE_TYPES, STAGE_VALUES } from './common-util/resources';
import { WizardContext } from './contexts/WizardContext';
import ImportDefaultForm from './ImportDefaultForm';
import ImportWizard from './ImportWizard';

interface Props {
    initType: string;
    portfolioId: string;
}

const ImportPage: FunctionComponent<Props> = ({initType, portfolioId}) => {
    const [importState, setImportState] = useState({
        fileName: '',
        importId: '',
        stage: STAGE_VALUES.DEFAULT,
        type: initType || RESOURCE_TYPES[0].value,
    });

    const setStage = (stage: STAGE_VALUES) => {
        setImportState({...importState, stage});
    };

    const onTypeChange = (type: string) => {
        setImportState({...importState, type});
    };

    const setImportId = (importId: string) => {
        setImportState({...importState, importId});
    };

    const setFileName = (fileName: string) => {
        setImportState({...importState, fileName});
    };
    
    if (importState.stage === STAGE_VALUES.DEFAULT) {
        return (
            <ImportDefaultForm
                portfolioId={portfolioId}
                type={importState.type}
                onTypeChange={onTypeChange}
                setFileName={setFileName}
                setStage={setStage}
                setImportId={setImportId}
            />
        );
    } else if (importState.stage === STAGE_VALUES.WIZARD) {
        const wizardContext = {
            fileName: importState.fileName,
            importId: importState.importId,
            portfolioId: portfolioId,
            setStage,
            type: importState.type,
        };
        return (
            <WizardContext.Provider value={wizardContext}>
                <ImportWizard />
            </WizardContext.Provider>
        );
    }
    return null;
};

export default ImportPage;
